module.exports = __webpack_public_path__ + "img/9a21b26.png";